export const creditCardWarning = () => (
  <p className="explanation warning">
    <strong>Warning: </strong> Before applying for any credit card, you should
    figure out what your credit score is first. We recommend{' '}
    <a href="https://www.creditkarma.com">Credit Karma</a> to get your free
    credit score.
  </p>
)

export const loanWarning = () => (
  <p className="explanation warning">
    <strong>Warning: </strong> Before applying for any loan, you should figure
    out what your credit score is first. We recommend{' '}
    <a href="https://www.creditkarma.com">Credit Karma</a> to get your free
    credit score.
  </p>
)
